import * as React from "react";
import type { SVGProps } from "react";
const SvgInformationdisclosureIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="informationdisclosure_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M426.667 341.333h256a42.667 42.667 0 1 0 0-85.333h-256a42.667 42.667 0 0 0 0 85.333zM341.333 512h341.334a42.667 42.667 0 0 0 0-85.333H341.333a42.667 42.667 0 0 0 0 85.333zm0 170.667h341.334a42.667 42.667 0 0 0 0-85.334H341.333a42.667 42.667 0 0 0 0 85.334zm512-597.334H170.667A42.667 42.667 0 0 0 128 128v768a42.667 42.667 0 0 0 68.267 34.133L284.587 864l87.893 66.133a42.667 42.667 0 0 0 51.2 0L512 864l88.32 66.133a42.667 42.667 0 0 0 51.2 0L739.413 864l88.32 66.133a42.667 42.667 0 0 0 61.867-11.818A42.667 42.667 0 0 0 896 896V128a42.667 42.667 0 0 0-42.667-42.667zm-42.666 725.334-45.654-34.134a42.667 42.667 0 0 0-51.2 0l-87.893 66.134-88.32-66.134a42.667 42.667 0 0 0-51.2 0l-88.32 66.134-87.893-66.134a42.667 42.667 0 0 0-51.2 0l-45.654 34.134v-640h597.334v640z"
    />
  </svg>
);
export default SvgInformationdisclosureIcon;
